import { Application, FlipIntent, NOOP_VOID, ScopeSlot } from 'wdc-cube'
import { AttrIds, ParamIds, Places } from '../Constants'

export class MainKeys {
    protected _intent: FlipIntent
    protected _app: Application

    public allow: boolean

    constructor(app: Application, intent?: FlipIntent) {
        this.allow = true
        this._app = app
        this._intent = intent ? intent : app.newFlipIntent(this.place)
    }

    public get place() {
        return Places.main
    }

    public get targetPlace() {
        return this._intent.place
    }

    public get last() {
        return !this.allow || this.targetPlace === this.place
    }

    public flip(): Promise<void> {
        return this._app.flipToIntent(this._intent)
    }

    // :: Parameters

    public get resetPassword() {
        return this._intent.getParameterAsBoolean(ParamIds.resetPassword) ?? false
    }

    public set resetPassword(value: boolean) {
        if (value) {
            this._intent.setParameter(ParamIds.resetPassword, value)
        } else {
            this._intent.setParameter(ParamIds.resetPassword, null)
        }
    }

    public get changePassword() {
        return this._intent.getParameterAsBoolean(ParamIds.changePassword) ?? false
    }

    public set changePassword(value: boolean) {
        if (value) {
            this._intent.setParameter(ParamIds.changePassword, value)
        } else {
            this._intent.setParameter(ParamIds.changePassword, null)
        }
    }

    public get changePasswordToken() {
        return this._intent.getParameterAsString(ParamIds.changePasswordToken) || ''
    }

    public set changePasswordToken(value: string | undefined) {
        if (value) {
            this._intent.setParameter(ParamIds.changePasswordToken, value)
        } else {
            this._intent.setParameter(ParamIds.changePasswordToken, null)
        }
    }

    public get microsoftLoginCode() {
        return this._intent.getParameterAsString(ParamIds.microsoftLoginCode) || ''
    }

    public set microsoftLoginCode(value: string) {
        if (value) {
            this._intent.setParameter(ParamIds.microsoftLoginCode, value)
        } else {
            this._intent.setParameter(ParamIds.microsoftLoginCode, null)
        }
    }

    public get googleLoginCode() {
        return this._intent.getParameterAsString(ParamIds.googleLoginCode) || ''
    }

    public set googleLoginCode(value: string) {
        if (value) {
            this._intent.setParameter(ParamIds.googleLoginCode, value)
        } else {
            this._intent.setParameter(ParamIds.googleLoginCode, null)
        }
    }

    // :: Compliance

    public get compliance() {
        return this._intent.getParameterAsBoolean(ParamIds.compliance) ?? false
    }

    public set compliance(value: boolean) {
        if (value) {
            this._intent.setParameter(ParamIds.compliance, value)
        } else {
            this._intent.setParameter(ParamIds.compliance, null)
        }
    }

    // :: parentSlot

    public get parentSlot() {
        return this._intent.getScopeSlot(AttrIds.parentSlot) ?? NOOP_VOID
    }

    public set parentSlot(value: ScopeSlot) {
        this._intent.setScopeSlot(AttrIds.parentSlot, value)
    }

    // :: dialogSlot

    public get dialogSlot() {
        return this._intent.getScopeSlot(AttrIds.dialogSlot) ?? NOOP_VOID
    }

    public set dialogSlot(value: ScopeSlot) {
        this._intent.setScopeSlot(AttrIds.dialogSlot, value)
    }
}
